module.exports = __webpack_public_path__ + "img/seating-banquet.97961a7e.svg";